import { Injectable }                           from "@angular/core";
import { Subject, Subscription }    from 'rxjs';
import { KeyValue } from '../shared/key-value';
import { AngularTokenService } from '@lakshvairav/angular-token';
import { AuthorizationService } from './authorization.service';
import { Router } from '@angular/router';
import { webSocket,WebSocketSubject} from 'rxjs/webSocket';

@Injectable()
export class WebsocketService {

    private ws: WebSocketSubject<any>;
    private socket: Subscription;
    private url: string;

    public message: Subject<Object> = new Subject();
    public opened: Subject<boolean> = new Subject();
    selectedSession: any;

    constructor(private router: Router, private _tokenService: AngularTokenService,
      private KeyValueService: KeyValue, public authService: AuthorizationService) {
    }

    public close():void{
        if(this.socket){
            this.socket.unsubscribe();
        }
        if(this.ws){
            this.ws.complete();
        }
    }

    public sendMessage( message:string ):void{
        if(this.ws){
            this.ws.next( message );
        }
    }

    public start( url: string ):void{
        const self = this;

        this.url = url;

        this.ws = webSocket( {
          url: this.url,
          serializer: msg => {
              return msg;
          },
          deserializer: ({ data }) => {
              return JSON.parse(data);
          }
        });

        this.socket = this.ws.subscribe( {

            next: ( data:MessageEvent ) => {
                if( data[ 'type' ] == 'welcome' ){
                    self.opened.next( true );
                }
                this.message.next( data );
            },
            error: () => {

                self.opened.next( false );
                this.message.next( { type: 'closed' } );

                self.socket.unsubscribe();

                setTimeout( () => {
                    self.start( self.url );
                }, 1000 );

            },
            complete: () => {
                this.message.next( { type: 'closed' } );
            }

        } );

    }

    // logout or redirect users based on websocket notification
    wsocketAction(data): void {
      const currentSession = this.KeyValueService.getCurrentSession();
      this.selectedSession = currentSession ? currentSession.name : '';
      const message = data.message.message;
      let username = '';
      if (this._tokenService.currentUserData !== null && this._tokenService.currentUserData !== undefined) {
        username = this._tokenService.currentUserData.uid;
      }
      if(username === ''){
        // console.log('User not logged in ws ', data);
      } else {
        try{
          // console.log(message.action);
          // console.log('message.action ...')
    
          switch (message.action) {
            case 'refresh-timer' : this.update_student_timer(message); break;
            case 'sim-progress' : this.sim_progress(message); break;
            case 'logout' : this.user_logout(username, message); break;
            case 'navigate' : this.page_navigation(username, message); break;
            case 'logout-popup' : this.student_account_lock(username, message); break;
            case 'popup-open' : this.execution_pop_up_open(username, message); break;
            case 'popup-close' : this.execution_pop_up_close(username, message); break;
            case 'team-update' : this.update_team_data(username, message); break;
            case 'decision-submited' : this.student_logout_popup(username, message); break;
            case 'reports-navbar-update' : this.update_report_navbar(username, message); break;
            case 'whatif-progress' : this.whatif_progress(message); break;
            case 'decision-created': this.updateDecisionStatus(message); break;
            case 'team-data': this.updateSimulationTeamData(message); break;
            case 'start_report': this.start_report_action(message); break;
            default : break;
          }
        }catch(err){
          // console.log(err)
        }
      }
    }

    isMessageForCurrentUser(username, message): boolean {
      if (!message.username) {
        return true;
      }

      if (Array.isArray(message.username)) {
        return message.username.includes(username);
      }

      return message.username === username;
    }

    isSelectedSession(message): boolean {
      const currentSession = this.KeyValueService.getCurrentSession();
      if (!currentSession || (!message.session && !message.session_id)) {
        return true;
      }

      if (message.session_id !== undefined && currentSession.id !== undefined) {
        return Number(message.session_id) === Number(currentSession.id);
      }

      return message.session === currentSession.name || Number(message.session) === Number(currentSession.id);
    }

    shouldHandleUserMessage(username, message): boolean {
      return this.isMessageForCurrentUser(username, message) && this.isSelectedSession(message);
    }

    start_report_action(message) {
      const id = message.session_id || message.session;
      // code to remove localstorage item show_reports_session_id if it matches the id
        localStorage.removeItem("show_reports_session_id");
        this.KeyValueService.start_report_action(id);
    }

    update_student_timer(message) {
      console.log("Refresh Timer ************* "+message)
      this.KeyValueService.update_student_time_left(message);
    }

    sim_progress(message) {
      document.getElementById('what_if_progress_div').style.display = 'none'
      document.getElementById('sim_progress_div').innerHTML=message.status+"<br/><br/><br/><br/>"
      document.getElementById('sim_progress_div1').innerHTML=message.status+"<br/><br/><br/><br/>"
    }

    whatif_progress(message) {
      document.getElementById('what_if_progress_div').style.display = 'block'
      document.getElementById('what_if_progress_div').innerHTML=message.status+"<br/><br/><br/><br/>"
    }
    update_report_navbar(username, message) {
      if (this.shouldHandleUserMessage(username, message)) {
        this.authService.setBankDetails()
      }
    }

    // updates teams data in simulation status page.
    update_team_data(username, message) {
      if (this.shouldHandleUserMessage(username, message)) {
        this.KeyValueService.simulation_status_data_update('update_team_data');
      }
    }

    // automatically logs user out
    user_logout(username, message) {
      if (this.shouldHandleUserMessage(username, message)) {
        this.authService.logout();
      }
    }

    // navigates the user to session selection page
    page_navigation(username, message) {
      if (this.shouldHandleUserMessage(username, message)) {
        this.router.navigate([this.authService.getChangePath('')]);
      }
    }

    // automatically locks the student account
    student_account_lock(username, message) {
      const ele = document.getElementById('AccountLockModel').style.display;
      if (this.shouldHandleUserMessage(username, message)) {
        if (document.getElementById('myLogoutModel').style.display !== 'block' && ele !== 'block') {
          this.close_chat_pop_up();
          this.close_chat_alert_popup();
          document.getElementById('logoutopen').click();
        }
      }
    }

    // opens the execution popup
    execution_pop_up_open(username, message) {


      if (this.shouldHandleUserMessage(username, message)) {
        // this.close_chat_pop_up();
        // this.close_chat_alert_popup();
        if (message.status != undefined) {
          document.getElementById('sim_popup_header').innerText = message.status+"is executing whatif please wait"
        } else {
          document.getElementById('sim_popup_header').innerText = "Please wait for the execution to complete."
        }
        if (document.getElementById('execution-popup') == null) {
            document.getElementById('execution-popup1').classList.add('active');
            document.getElementById('execution_pop_up').style.display = 'block';
            document.getElementById('execution-popup1').click();

        } else {
            document.getElementById('execution_pop_up').style.display = 'block';
            document.getElementById('execution-popup').click();
        }
      }
    }

    // closes the execution popup
    execution_pop_up_close(username, message) {
      if (this.shouldHandleUserMessage(username, message)) {
        if (document.getElementById('execution-popup1').classList.contains('active')) {
          document.getElementById('execution-popup1').classList.remove('active');
          document.getElementById('sim_progress_div1').innerHTML="Please wait . Simulation is in progress."+"<br/><br/><br/><br/>"
          setTimeout(function(){
          document.getElementById('execution_pop_up').style.display = 'none';
          document.getElementById('execution-popup1').click();
          window.location.reload();
        }, 3000);
        } else if (document.getElementById('execution-popup') !== null) {
          document.getElementById('sim_progress_div').innerHTML="Please wait. Simulation is in progress."+"<br/><br/><br/><br/>"
          setTimeout(function(){
          document.getElementById('execution_pop_up').style.display = 'none';
          document.getElementById('execution-popup').click();
          window.location.reload();
          }, 3000);
        }
      }
    }

    // closes the chat pop up if it is opened.
    close_chat_pop_up() {
      const ele = document.getElementById('chatDashboardPopup');
      if (ele != null && ele.classList.contains('in')) {
        document.getElementById('chatPopUp').click();
      }
    }

    // closes the chat alert pop up.
    close_chat_alert_popup() {
      const ele = document.getElementById('chatAlertModal');
      if (ele != null && ele.classList.contains('in')) {
        document.getElementById('chatAlertPop').click();
      }
    }

    // locks the student account on decision submission
    student_logout_popup(username, message) {
      if (this.shouldHandleUserMessage(username, message)) {
        if (document.getElementById('AccountLockModel').style.display !== 'block') {
          this.close_chat_pop_up();
          this.close_chat_alert_popup();
          document.getElementById('logout_popup').click();
          this.authService.logout()
        }
      }
    }

    updateDecisionStatus(message) {
      this.KeyValueService.simulation_status_data_update(message);
    }

    updateSimulationTeamData(message) {
      this.KeyValueService.simulation_status_data_update(message);
    }    
}
